module.exports = __webpack_public_path__ + "img/selfie1.4ebae811.svg";